/*
 * O estado da seleção em massa: o modo ligado e os ids marcados.
 *
 * Um objeto só para o fórum inteiro (e não estado da página) porque quem
 * desenha a caixa é cada DiscussionListItem, quem desenha a barra é o
 * IndexPage, e os dois precisam ver a mesma seleção. Mudar de página da lista
 * (outra tag, outra ordenação) zera tudo — ver `reset`.
 */
import app from 'flarum/forum/app';
import { forumBool } from '../../../utils/settings';
class BulkSelection {
  active = false;
  /** Sobe a cada mudança: é o que os itens da lista (SubtreeRetainer) observam. */
  version = 0;
  ids = new Set();
  /** Último item clicado, para o shift+clique selecionar o intervalo. */
  anchor = null;
  has(discussion) {
    return this.ids.has(String(discussion.id()));
  }
  count() {
    return this.ids.size;
  }
  setActive(active) {
    this.active = active;
    this.clear();
  }
  toggle(discussion, range = false) {
    const id = String(discussion.id());
    if (range && this.anchor && this.anchor !== id) {
      const visible = loadedDiscussions().map(item => String(item.id()));
      const from = visible.indexOf(this.anchor);
      const to = visible.indexOf(id);
      if (from !== -1 && to !== -1) {
        // O intervalo segue o estado do item âncora, como num gerenciador de arquivos.
        const select = this.ids.has(this.anchor);
        visible.slice(Math.min(from, to), Math.max(from, to) + 1).forEach(itemId => select ? this.ids.add(itemId) : this.ids.delete(itemId));
        this.anchor = id;
        this.version++;
        return;
      }
    }
    if (this.ids.has(id)) this.ids.delete(id);else this.ids.add(id);
    this.anchor = id;
    this.version++;
  }
  selectAll() {
    loadedDiscussions().forEach(discussion => this.ids.add(String(discussion.id())));
    this.version++;
  }
  clear() {
    this.ids.clear();
    this.anchor = null;
    this.version++;
  }

  /** Os tópicos marcados que ainda estão no store (um excluído some daqui). */
  selected() {
    return [...this.ids].map(id => app.store.getById('discussions', id)).filter(discussion => !!discussion);
  }
  forget(discussion) {
    this.ids.delete(String(discussion.id()));
    this.version++;
  }
}
export const selection = new BulkSelection();

/** Os tópicos já carregados na lista, na ordem em que aparecem. */
export function loadedDiscussions() {
  return app.discussions.getPages().flatMap(page => page.items);
}

/** Quem modera algo nesta lista — a equipe ("staff"). */
export function canModerate(discussion) {
  const model = discussion;
  return !!(model.canSticky?.() || model.canLock?.() || discussion.canDelete() || discussion.canHide() && discussion.user() !== app.session.user);
}
export function bulkAvailable() {
  if (!app.session.user || !forumBool('canelaBulkSelectEnabled', true)) return false;
  return !!app.session.user.isAdmin?.() || loadedDiscussions().some(canModerate);
}
flarum.reg.add('ramon-canela', 'forum/features/extras/bulk/selection', { selection: selection,loadedDiscussions: loadedDiscussions,canModerate: canModerate,bulkAvailable: bulkAvailable, });